import React from 'react'
import { useTranslation } from 'react-i18next'
import "./listData.scss"

function ListData() {
  const { t } = useTranslation()

  return (
    <div className='container-list-data'>
      <div className="texts-list-data">
        <div>
          <h1>{t("suport.list_data.realtime_data.title")}</h1>
          <p>{t("suport.list_data.realtime_data.section_text_1")}</p>
          <p>{t("suport.list_data.realtime_data.section_text_2")}</p>
        </div>
        <br />
        <div>
          <h1>{t("suport.list_data.data_management.title")}</h1>
          <p>{t("suport.list_data.data_management.section_text")}</p>
        </div>
        <br />
        <div>
          <h1>{t("suport.list_data.interactive.title")}</h1>
          <p>{t("suport.list_data.interactive.section_text")}</p>
        </div>
        <br />
        <div>
          <h1>{t("suport.list_data.process_automation.title")}</h1>
          <p>{t("suport.list_data.process_automation.section_text")}</p>
        </div>
      </div>
    </div>
  )
}

export default ListData